import { t } from "ttag";

import type { Plan } from "../models";
import { DURATION_IN_MONTHS } from "../models";

export const getMonthsDurationText = (
  durationInMonths: Plan["durationInMonths"],
) => {
  return durationInMonths === DURATION_IN_MONTHS.MONTHLY
    ? t`month`
    : `${durationInMonths} ${t`months`}`;
};
